// Ajout au panier sans rechargement pour l'upsell (« Complete the set ») et les tuiles achetables.
// Même comportement que le bouton d'achat d'Horizon : l'image vole jusqu'à l'icône du panier,
// puis le tiroir se met à jour et s'ouvre (réglage « auto_open_cart_drawer »).
// Formulaires concernés : <form data-amira-quick-add data-image="..."> ; sans JS, ils restent de simples POST.
import { CartLinesUpdateEvent } from '@shopify/events';
import { fetchConfig } from '@theme/utilities';

const ADDED_MS = 1800;

function flyToCart(image, source) {
  const cartIcon = document.querySelector('.header-actions__cart-icon');
  if (!image || !source || !cartIcon || !customElements.get('fly-to-cart')) return;
  const el = /** @type {any} */ (document.createElement('fly-to-cart'));
  el.classList.add('fly-to-cart--main');
  el.style.setProperty('background-image', `url(${image})`);
  el.style.setProperty('--start-opacity', '0');
  el.source = source;
  el.destination = cartIcon;
  document.body.appendChild(el);
}

async function fetchCart() {
  const items = document.querySelector('cart-items-component');
  if (items) {
    await customElements.whenDefined('cart-items-component');
    return /** @type {any} */ (items).fetchCartData();
  }
  const res = await fetch(`${Theme.routes.cart_url}.json`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
  return res.json();
}

document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-amira-quick-add')) return;
  event.preventDefault();

  const button = form.querySelector('button[type="submit"]');
  if (!button || button.getAttribute('aria-busy') === 'true') return;
  button.setAttribute('aria-busy', 'true');
  const label = button.textContent;

  const formData = new FormData(form);
  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((el) => /** @type {HTMLElement} */ (el).dataset.sectionId)
    .filter(Boolean);
  if (sectionIds.length) formData.append('sections', sectionIds.join(','));
  const quantity = Number(formData.get('quantity')) || 1;

  flyToCart(form.dataset.image, form.dataset.flySource ? form.closest(form.dataset.flySource)?.querySelector('img') ?? button : button);

  const deferred = CartLinesUpdateEvent.createPromise();
  form.dispatchEvent(new CartLinesUpdateEvent({
    action: 'add',
    context: 'product',
    lines: [{ merchandiseId: String(formData.get('id')), quantity }],
    promise: deferred.promise,
  }));

  try {
    const cfg = fetchConfig('javascript', { body: formData });
    const response = await fetch(Theme.routes.cart_add_url, { ...cfg, headers: { ...cfg.headers, Accept: 'text/html' } }).then((r) => r.json());
    const cart = await fetchCart();
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, source: 'amira-quick-add', itemCount: quantity, sections: response.sections, didError: Boolean(response.status) },
    });
    button.textContent = response.status ? (response.message || label) : '✓';
  } catch (error) {
    deferred.reject(error);
    console.error(error);
  } finally {
    setTimeout(() => { button.textContent = label; button.removeAttribute('aria-busy'); }, ADDED_MS);
  }
});
